import { render, staticRenderFns } from "./hrProjectView.vue?vue&type=template&id=04d73374"
import script from "./hrProjectView.vue?vue&type=script&lang=js"
export * from "./hrProjectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports